export const PHARMACY_STATUS_AC = 'AC';
export const PHARMACY_STATUS_TC = 'TC';
export const PHARMACY_STATUS_PC = 'PC';
